import React from "react";

// The Landscape of Practice
export default function PracticeMapTab({ onOpenWeek }) {
  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">The Landscape of Practice</h2>
        {onOpenWeek && (
          <button className="btn secondary" onClick={onOpenWeek}>
            See this week’s invitation
          </button>
        )}
      </div>

      <p className="sm muted">
        This isn’t a roadmap to some better future you. It’s a{" "}
        <strong>living landscape</strong> you can wander in. There is nowhere to
        get to — only places to become more intimate with.
      </p>

      <div className="grid md-g-3" style={{ marginTop: 12 }}>
        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            Foundations
          </h3>
          <ul className="sm" style={{ paddingLeft: 18, margin: 0 }}>
            <li>Arriving in the body and breath</li>
            <li>Noticing thoughts as events in the mind</li>
            <li>Letting things be as they are, just for now</li>
          </ul>
        </div>

        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            Relating
          </h3>
          <ul className="sm" style={{ paddingLeft: 18, margin: 0 }}>
            <li>Meeting emotions with curiosity instead of judgment</li>
            <li>Listening in relationships with your whole body</li>
            <li>Remembering common humanity</li>
          </ul>
        </div>

        <div className="card">
          <h3 className="h2" style={{ marginTop: 0 }}>
            Living It
          </h3>
          <ul className="sm" style={{ paddingLeft: 18, margin: 0 }}>
            <li>Bringing awareness into work and money choices</li>
            <li>Relating wisely to devices and time</li>
            <li>Moving through change with as much kindness as possible</li>
          </ul>
        </div>
      </div>

      <p className="xs muted" style={{ marginTop: 16 }}>
        You can begin anywhere. Wherever you choose is the perfect place to
        practice.
      </p>
    </section>
  );
}
